import firebase from 'firebase/app';
import 'firebase/messaging';
import { siteConfig } from "../settings";

const DEBUG = siteConfig.DEBUG

var firebaseConfig = {
  apiKey: "AIzaSyCkXTWtWUTuIz8QzmE3MOfbvtV2LeYpiAE",
  authDomain: "urbanice-web-nitidev.firebaseapp.com",
  projectId: "urbanice-web-nitidev",
  storageBucket: "urbanice-web-nitidev.appspot.com",
  messagingSenderId: "137263598740",
  appId: "1:137263598740:web:cdeaf9f2f64ac1d213f881",
  measurementId: "G-41VJKJHPSC"
};

// Initialize Firebase
//firebase.initializeApp(firebaseConfig);
//firebase.analytics();

//const messaging = firebase.messaging();
//const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null

let messaging = null

if (firebase.messaging.isSupported()) {
  firebase.initializeApp(firebaseConfig)
  messaging = firebase.messaging()
} else {
  console.log('browser no-support FCM :(')
}

export const getToken = (setTokenFound, setFcmToken) => {
  DEBUG && console.log(`getToken`);

  return messaging.getToken({ vapidKey: 'BDrqraz-qLh6D9qQEpHkKIYAABnUEOkAbWOkuPCyDk1Zua8xkVDg263BXvPqQ7Q1rPD8zI-brR9ib1vo05lvbmk' }).then((currentToken) => {
    if (currentToken) {
      DEBUG && console.log('getToken_isToken for client: ', currentToken);
      localStorage.setItem('fcmToken', currentToken);
      setFcmToken(currentToken);
      setTokenFound(true)
      //return true;
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      DEBUG && console.log('getToken_No registration token available. Request permission to generate one.');
      setTokenFound(false);
      //return false;
      // shows on the UI that permission is required 
    }
  }).catch((err) => {
    DEBUG && console.log('getToken_An error occurred while retrieving token. ', err);
    // catch error while creating client token
  });
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export const onBackgroundMessageListener = () =>
  new Promise((resolve) => {
    messaging.onBackgroundMessage((payload) => {
      resolve(payload);
    });
  });

